import { render, staticRenderFns } from "./DesignFormItem.vue?vue&type=template&id=5f6fb289&scoped=true&"
import script from "./DesignFormItem.vue?vue&type=script&lang=js&"
export * from "./DesignFormItem.vue?vue&type=script&lang=js&"
import style0 from "./DesignFormItem.vue?vue&type=style&index=0&id=5f6fb289&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6fb289",
  null
  
)

export default component.exports